import * as React from 'react';
import { ICommentCountIndicatorProps } from './types';
import { CardCountIndicator } from '../CardCountIndicator/CardCountIndicator';
import { COMMENTS_TOOLTIP } from '../../wording';

export function CommentCountIndicator({
    active,
    commentsCount,
    onClick
}: ICommentCountIndicatorProps) {
    return (
        <CardCountIndicator
            active={active}
            icon={'comment'}
            tooltip={COMMENTS_TOOLTIP}
            onClick={onClick}
        >
            {commentsCount}
        </CardCountIndicator>
    );
}
